import React from 'react'
import { string, object, number, arrayOf } from 'prop-types'
import { useTheme, Typography, styled } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

const AddToCartCheckmarkYMAL = () => {
  const theme = useTheme()
  const CheckmarkContainer = styled('div')`
    display: flex;
    flex-direction: row;
    margin-top: auto;
    margin-bottom: auto;
  `

  const StyledCheckmark = styled(CheckCircleOutlineIcon)`
    margin-right: 5px;
  `
  return (
    <CheckmarkContainer>
      <StyledCheckmark sx={{ color: `${theme.palette.success.main}` }} />
      <Typography fontSize="16px" fontWeight="400" color={theme.palette.success.main}>
        Added to Cart
      </Typography>
    </CheckmarkContainer>
  )
}

export default AddToCartCheckmarkYMAL
